export function buildMapsUrl(trial) {
  const addressParts = [trial?.address, trial?.city, trial?.region, trial?.country].filter(Boolean);
  const query = encodeURIComponent(addressParts.join(', '));
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
}

export function buildTrialSourceUrl(trial) {
  const source = String(trial?.source || '').toLowerCase();
  const trialId = String(trial?.id || '');

  const healthCanadaMatch = trialId.match(/^hc-(\d+)$/i);
  if (source === 'health_canada' || healthCanadaMatch) {
    const submissionNo = healthCanadaMatch ? healthCanadaMatch[1] : '';
    if (submissionNo) {
      return `https://health-products.canada.ca/ctdb-bdec/brand/?submissionNo=${encodeURIComponent(submissionNo)}&lang=eng`;
    }
    return 'https://health-products.canada.ca/ctdb-bdec/?lang=eng';
  }

  return 'https://health-products.canada.ca/ctdb-bdec/?lang=eng';
}

export function toPatientFriendlyStatus(status) {
  const normalized = String(status || '').trim().toLowerCase();
  if (normalized === 'recruiting') return 'Actively recruiting';
  if (normalized === 'not_yet_recruiting') return 'Not yet recruiting';
  if (normalized === 'active_not_recruiting') return 'Active, not recruiting';
  if (normalized === 'completed') return 'Completed';
  return status || 'Unknown';
}

export function summarizeTrialsForChatbot(trials, { savedOnly = false } = {}) {
  const list = Array.isArray(trials) ? trials : [];
  const filtered = savedOnly ? list.filter((t) => t.isSaved) : list;

  if (filtered.length === 0) {
    return 'No clinical trials are currently selected.';
  }

  const lines = filtered.slice(0, 8).map((trial, index) => {
    const reasons = Array.isArray(trial.matchReasons) && trial.matchReasons.length > 0
      ? ` Why this may fit: ${trial.matchReasons.join(' ')}`
      : '';

    return `${index + 1}. ${trial.title} (${trial.trialIdentifier}) at ${trial.institution}, ${trial.city}. Status: ${toPatientFriendlyStatus(trial.recruitingStatus)}. Eligibility: ${trial.eligibilitySummary}.${reasons}`;
  });

  return `Clinical trial summary for patient discussion:\n${lines.join('\n')}`;
}

export function getUniqueValues(trials, field) {
  const values = new Set();
  (Array.isArray(trials) ? trials : []).forEach((trial) => {
    const value = trial?.[field];
    if (Array.isArray(value)) {
      value.forEach((entry) => {
        if (entry) values.add(String(entry));
      });
    } else if (value) {
      values.add(String(value));
    }
  });
  return Array.from(values).sort((a, b) => a.localeCompare(b));
}
